import React from "react"
import { adaptNFe } from "../../../../../api/nfe"

import Modal from "../../../../../_components/Modal"
import Text from "../../../../../_components/Text"
import Button from "../../../../../_components/Button"
import LoadingInput from "../../../../../_components/LoadingInput"
import { showSnackBar } from "../../../../../utils"

const DEFAULT_RANGE = { start_number: 1, end_number: 11, series: 1 }

const START_NUMBER_ID = "a2915682-5890-4571-bf46-59113dcf70db-adjment-note-start-number"
const END_NUMBER_ID = "b9788701-0c60-4910-ac01-337b76494cc5-adjment-note-end-number"
const SERIES_ID = "4b9e49fc-a9c5-4c46-b5c6-3f05fe184d32-adjment-note-series"

export default props => {
    const [show, setShow] = React.useState(false)
    const [showAjustar, setShowAjustar] = React.useState(false)
    const [finish, setFinish] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [range, setRange] = React.useState(DEFAULT_RANGE)
    const [enableButton, EnableButton] = React.useState(true)

    function closeModal() {
        if (loading) {
            showSnackBar("Requisição em andamento ...")
        }
        setShow(false)
        setRange(DEFAULT_RANGE)
    }

    function onChange(e) {
        let { name: key, value } = e.target
        if (parseInt(value) < 1) {
            value = 1
        }
        const newRange = { ...range }
        newRange[key] = value
        setRange(newRange)
        setTimeout(() => {
            verifyRangeLimit()
        }, 100)
    }

    function verifyRangeLimit() {

    }

    function handleInitAdjument() {
        setLoading(true)
        adaptNFe(range)
            .then(resp => {
                setLoading(false)
                setShow(false)
                setFinish(true)
            })
            .catch(resp => {
                setLoading(false)
            })
    }

    function setInputFocus() {
        setTimeout(() => {
            try { document.getElementById(START_NUMBER_ID).focus() } catch (error) { }
        }, 200)
    }

    React.useEffect(setInputFocus, [show])


    return <div>
        <p>
            Algo está errado?
        </p>
        <Button
            onClick={() => setShow(true)}>
            <strong className="text-white">
                Consultar nota(s)<i className="fas fa-wrench ml-2" />
            </strong>
        </Button>
        <Modal
            title="Corrigir documentos"
            show={show}
            onHide={closeModal} >
            <div className="row">
                <div className="col-12">
                    <p>
                        Consulta de documentos:
                    </p>
                    <ul>
                        <li>
                            O sistema realizará uma consulta na SEFAZ e irá corrigir os documentos (NF-e)
                        </li>
                        <li>
                            Intervalo máximo de 30 documentos (NF-e) por consulta
                        </li>
                    </ul>
                </div>
                <div className="col-4 col-xs-12">
                    <p className="lead">
                        Número inicial
                    </p>
                    <LoadingInput
                        name="start_number"
                        type="number"
                        id={START_NUMBER_ID}
                        loading={loading}
                        value={range.start_number}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4 col-xs-12">
                    <p className="lead">
                        Número Final
                    </p>
                    <LoadingInput
                        name="end_number"
                        type="number"
                        value={range.end_number}
                        loading={loading}
                        id={END_NUMBER_ID}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4 col-xs-12">
                    <p className="lead">
                        Série
                    </p>
                    <LoadingInput
                        name="series"
                        type="number"
                        loading={loading}
                        value={range.series}
                        id={SERIES_ID}
                        onChange={onChange}
                    />
                </div>
                <div className={`${showAjustar ? "col-4 col-xs-12" : "d-none"}`}>
                    <p className="lead">
                        Recuperar
                    </p>
                    <LoadingInput
                        name="recuperar"
                        as="select"
                        loading={loading}
                        value={range.recuperar}
                        id={"asasd"}
                        onChange={onChange}>
                            <option value="sim">SIM</option>
                            <option value="não" selected>NÃO</option>
                        </LoadingInput>
                </div>
                <div className="col-12">
                <Button as="text" onClick={()=>setShowAjustar( !showAjustar )}>
                    avançado
                </Button>
                </div>
                <div className="col-12">
                    <div className="alert alert-primary">
                        <p className="lead p-0 m-0">
                            Intervalo: <strong>
                                {
                                    range.end_number - range.start_number
                                }
                            </strong>
                        </p>
                    </div>
                </div>
                <div className="col-md-4 mt-3 mx-auto d-flex jusity-content-center">
                    <Button
                        disabled={!enableButton || loading}
                        onClick={handleInitAdjument}>
                        <strong>
                            {
                                loading
                                    ? "Correção em andamento"
                                    : "Iniciar Correção dos documentos"
                            }
                        </strong>
                    </Button>
                </div>
            </div>
        </Modal>
        <Modal title="Correção finalizada." show={finish}>
            <div>
                <h2 className="text-center">
                    Correção aplicada aos documentos.
                </h2>
                <div className="d-flex justify-content-center">
                    <Button onClick={() => { window.location.reload() }}>
                        Finalizar
                    </Button>
                </div>
            </div>
        </Modal>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/AdjustmentNotes/index.jsx